import { apiService } from '@/services/api/apiService';
import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';

interface userProfile {
    id: any;
    firstName: any,
    lastName: any,
    dob: any,
    genderId: any,
    phone: any,
    email: any,
    profileImageUrl: any,
    auditTrailId: any,
    isActive: boolean
}

interface UserProfileState {
    data: userProfile[];
    loading: boolean;
    error: string | null;
}

const PORT = import.meta.env.VITE_USERS_PORT;
const MASTERURL = import.meta.env.VITE_API_USERS_URL;

export const fetchuserProfile = createAsyncThunk<userProfile[], void, { rejectValue: string }>(
    'userProfile/fetchuserProfile',
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiService.get<{ data: userProfile[] }>('/get_all_user_profile', PORT, MASTERURL);
            return response.data; // assuming your response has the .data field
        } catch (error) {
            return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
        }
    }
);


export const createuserProfile = createAsyncThunk<userProfile, any, { rejectValue: string }>(
    'userProfile/createuserProfile',
    async (params, { rejectWithValue }) => {
        try {
            const response = await apiService.post<{ data: userProfile }>('create_user_profile', params, PORT, MASTERURL);
            return response.data;
        } catch (error) {
            return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
        }
    }
);

export const updateuserProfile = createAsyncThunk<userProfile, any, { rejectValue: string }>(
    'userProfile/updateuserProfile',
    async (params, { rejectWithValue }) => {
        try {
            const response = await apiService.put<{ data: userProfile }>('update_spice_level', params, PORT, MASTERURL);
            return response.data;
        } catch (error) {
            return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
        }
    }
);

// Diet Mapping Code
// export const fetchDietPreferences = createAsyncThunk<userProfile[], void, { rejectValue: string }>(
//     'userProfile/fetchDietPreferences',
//     async (_, { rejectWithValue }) => {
//         try {
//             const response = await apiService.get<{ data: userProfile[] }>('/get_all_user_profile', PORT, MASTERURL);
//             return response.data;
//         } catch (error) {
//             return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
//         }
//     }
// );

// export const createDietPreferences = createAsyncThunk<userProfile, any, { rejectValue: string }>(
//     'userProfile/createDietPreferences',
//     async (params, { rejectWithValue }) => {
//         try {
//             const response = await apiService.post<{ data: userProfile }>('create_user_profile', params, PORT, MASTERURL);
//             return response.data;
//         } catch (error) {
//             return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
//         }
//     }
// );

// export const updateDietPreferences = createAsyncThunk<userProfile, any, { rejectValue: string }>(
//     'userProfile/updateDietPreferences',
//     async (params, { rejectWithValue }) => {
//         try {
//             const response = await apiService.put<{ data: userProfile }>('update_spice_level', params, PORT, MASTERURL);
//             return response.data;
//         } catch (error) {
//             return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
//         }
//     }
// );

export const userProfileSlice = createSlice({
    name: 'userProfile',
    initialState: {
        data: [],
        loading: false,
        error: null,
    } as UserProfileState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchuserProfile.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchuserProfile.fulfilled, (state, action: PayloadAction<userProfile[]>) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchuserProfile.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? 'Unknown error';
            })
            .addCase(createuserProfile.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(createuserProfile.fulfilled, (state, action: PayloadAction<userProfile>) => {
                state.loading = false;
                state.data.push(action.payload);
            })
            .addCase(createuserProfile.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? 'Unknown error';
            })
            .addCase(updateuserProfile.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateuserProfile.fulfilled, (state, action: PayloadAction<userProfile>) => {
                state.loading = false;
                state.data.push(action.payload);
            })
            .addCase(updateuserProfile.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? 'Unknown error';
            })
    },
});

export default userProfileSlice.reducer;